import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Icon from '../Icon';
import { scale } from '../../utils/scale.utils';
import IconWithName from '../ExpenseWidget/IconWithName';
import BaseText from '../BaseText';
import { Color, CommonProperties } from '../../styles';

const getIsExpenseCar = (isExpense, iconName) => {
  return isExpense && iconName === 'car';
};

const SearchTypeCheckbox = (props) => {
  const { onPress, selected, iconName, disabled, iconLabel, isExpense = false } = props;
  const selectedColor = selected ? Color.background : Color.primary;
  const isExpenseCar = getIsExpenseCar(isExpense, iconName);
  return (
    <TouchableOpacity
      style={[styles.tripTypeButton, props.style]}
      onPress={() => {
        onPress(!selected);
      }}
      disabled={disabled ? disabled : false}
    >
      <View style={[styles.checkboxContainer, selected && styles.checkboxSelected]}>
        {iconLabel && (
          <View style={{ alignItems: 'center', ...CommonProperties.py3 }}>
            <Icon
              name={iconName}
              size={isExpenseCar ? 40 : 36}
              color={selected ? Color.background : Color.primary}
            />
            <BaseText
              style={[
                { color: selectedColor, ...CommonProperties.h4, ...styles.iconLabel },
                isExpense && { marginTop: isExpenseCar ? -10 : -4 },
              ]}
            >
              {iconLabel}
            </BaseText>
          </View>
        )}
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  tripTypeButton: {
    flexGrow: 1,
    borderRightWidth: scale(0.7),
    // undo the following change after demo
    borderColor: Color.formDividerColor,
  },
  checkboxContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkboxSelected: {
    backgroundColor: Color.active,
  },
  iconLabel: {
    marginTop: -5,
    marginBottom: 6,
  },
});

export default SearchTypeCheckbox;
